import { getScalableStyleFromLocalStorage, setScalableStyleToLocalStorage } from './functions';
import {
    buyBox,
    buyBoxPraemienShop,
    cableSnapScalableStyle,
    cartScalableStyle,
    checkoutChargeScalableStyle,
    checkoutScalableStyle,
    crosssellingAccessoriesCard,
    customLineItem,
    customLineItemCheckout,
    defaultScalableStyle,
    minimalSmartProductCard,
    mobileProductCard,
    offerLineItem,
    praemienShop,
    smartProductCard,
    smartProductList
} from './presets';
import type { ScalableProductCARD_STYLE_TYPE, ScalableStyle } from './types';

const functions = { getScalableStyleFromLocalStorage, setScalableStyleToLocalStorage };
const presets = {
    cableSnapScalableStyle,
    checkoutScalableStyle,
    defaultScalableStyle,
    checkoutChargeScalableStyle,
    smartProductCard,
    cartScalableStyle,
    customLineItemCheckout,
    customLineItem,
    buyBox,
    smartProductList,
    offerLineItem,
    mobileProductCard,
    minimalSmartProductCard,
    crosssellingAccessoriesCard,
    praemienShop,
    buyBoxPraemienShop
};

export const scalableStyle = { functions, presets };

export type { ScalableProductCARD_STYLE_TYPE, ScalableStyle };
